import React from "react";
import ComparisonContentHours from "../../home/cards/reflection/ComparisonContentHours";
import ComparisonElement from "../../home/cards/reflection/ComparisonElement";
import EditReflectionLineChart from "./EditReflectionLineChart";

export default function EditReflectionChart({
  reflection,
  reflectionElement,
  reflectionHours,
  controller,
  showToggleChartMenu,
}) {
  return (
    <>
      <ComparisonElement element={reflectionElement} />
      <ComparisonContentHours totalMinutes={reflection.target_hours * 60} />

      <EditReflectionLineChart
        reflection={reflection}
        reflectionHours={reflectionHours}
        controller={controller}
        showToggleChartMenu={showToggleChartMenu}
      />
    </>
  );
}
 